import React from 'react';

type PercentageFormatterProps = {
  value: number | string | undefined;
};

const PercentageFormatter = ({ value }: PercentageFormatterProps) => {
  const parsedValue = parseFloat((value ?? 0)?.toString());

  const [partOne, partTwo] = parsedValue.toFixed(1).toString().split('.');

  return (
    <div className={`${value === 0 ? 'text-[#CDCDCD]' : ''}`}>
      <span>{partOne}</span>
      <span className="text-xsm">.{partTwo}%</span>
    </div>
  );
};

export default PercentageFormatter;
